import React from "react";
import "../css/Header.css";
import { SiDelicious } from "react-icons/si";
import { MdOutlineStars } from "react-icons/md";

const Header = () => {
  return (
    <>
      <div className="main-container">
        <div className="container-fluid">
          <img src="/images/Topimg1.jpg" alt="Head Image" className="w-100" />
        </div>
        <div className="gray-container d-flex text-white ">
         
            <p>
              <span className="pr-2">
                <SiDelicious />
              </span>
              Fast Delivery and Exchanges
            </p>
            <p>
              <span className="pr-2">
                <MdOutlineStars />
              </span>
              100% Genuine Brands
            </p>
          
        </div>
      </div>
    </>
  );
};

export default Header;
